import { Link } from "react-router-dom";
import { SHOWCASE } from "@/lib/site";
import { BeforeAfterSlider } from "@/components/home/BeforeAfterSlider";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";

export const Showcase = () => (
  <section data-testid="showcase-section" aria-labelledby="showcase-heading" className="section section-alt">
    <div className="container-site">
      <SectionHeading id="showcase" title="See The Difference" accent="Difference" sub="Real jobs, real results. Drag the handle to compare." />
      <div className="mt-12 flex flex-col gap-6">
        <Reveal>
          <BeforeAfterSlider {...SHOWCASE[0]} featured />
        </Reveal>
        <div className="grid gap-6 md:grid-cols-2">
          {SHOWCASE.slice(1).map((item, i) => (
            <Reveal key={item.id} delay={(i + 1) * 60}>
              <BeforeAfterSlider {...item} />
            </Reveal>
          ))}
        </div>
      </div>
      <Reveal className="mt-12">
        <Link to="/gallery" data-testid="showcase-gallery-button" className="btn btn-outline w-full sm:w-auto">
          View All Our Work
        </Link>
      </Reveal>
    </div>
  </section>
);
